module.exports = __webpack_public_path__ + "media/images/missing/images/default-3c00934d8e638593c0e00ad46b55cd08.png";